import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/AddHomeLillyIllustration.tsx
const AddHomeLillyIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "add-home-lilly.svg",
		alt: t("illustration.imageAlt.addHomeIllustration")
	});
};

//#endregion
export { AddHomeLillyIllustration };